import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, IsEmptyFilterOperatorComponent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { GridSettings, Info } from '../../../../../core/common';
import { ISampleFinish, ISampleSubCategory, ISampleCategory, IGetSampleProductOrderDetailsByHeader, IGetSampleSubCategoryCostBySubcategoryId, ISampleSubCategoryExist } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-sample-request-admin',
  templateUrl: './sample-request-admin.component.html',
  styleUrls: ['./sample-request-admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SampleRequestAdminComponent implements OnInit {

  //#region member variables
  isClothCategory: boolean = false;
  finishSampleLoading: boolean;
  finishSampleGridView: GridDataResult;
  finishCategoryForm: FormGroup;
  finishSampleForm: FormGroup;
  categorySaveInProcess: boolean;
  subCategorySaveInProcess: boolean;

  categoryData: ISampleCategory[];
  selectedCategory: string = ""
  selectedCategoryId: number;
  selectedGender: string = "";
  selectedSize: string = "";
  filePath: string;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  subCategoryFileUpload: string = "";
  addEditCategoryId: number = 0;
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif"],
  };
  isAddHideColumns: boolean = false;
  isEditHideColumns: boolean = false;
  isEditCategoryColumns: boolean = false;
  isEditedSampleSubCategory: boolean = false;
  isCopiedSampleSubCategory: boolean = false;
  sampleSubCategoryTitleText: string = '';
  sampleCategoryTitleText: string = '';
  costHeaderGridData: GridDataResult;
  costGridData: any[] = [];
  costLoading: boolean;
  isSampleSubCategoyCost: boolean;
  imageUrl: string;
  isDisableExternal: boolean=false;

  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private router: Router  ) { }

  ngOnInit() {
    this.loadFinishSampleGrid();
    this.initializeFormControls();
    this.isSampleSubCategoyCost = false;
    this.imageUrl = environment.imageUrl;
  }
  public uploadImage = false;
  public inputURL = false;
  public inputRGB = false;
  toggleUploadImage() {
    this.inputURL = false;
    this.inputRGB = false;
    this.uploadImage = true;
    //this.finishSampleForm.controls.fileUpload.setValue(null);
    this.finishSampleForm.controls.inputURL.setValue(null);
    this.finishSampleForm.controls.inputR.setValue(null);
    this.finishSampleForm.controls.inputG.setValue(null);
    this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
  }
  toggleInputURL() {
    this.uploadImage = false;
    this.inputRGB = false;
    this.inputURL = true;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    //this.finishSampleForm.controls.inputURL.setValue(null);
    this.finishSampleForm.controls.inputR.setValue(null);
    this.finishSampleForm.controls.inputG.setValue(null);
    this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
    this.filePath = "";
  }
  toggleInputRGB() {
    this.inputURL = false;
    this.uploadImage = false;
    this.inputRGB = true;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    this.finishSampleForm.controls.inputURL.setValue(null);
    //this.finishSampleForm.controls.inputR.setValue(null);
    //this.finishSampleForm.controls.inputG.setValue(null);
    //this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
    this.filePath = "";
  }

  public costLblText = {
    subCategoryDescriptionLbl: 'Product Description',
    costLbl: 'Cost',
    effectiveFromLbl: 'Effective From',
    effectiveToLbl: 'Effective To',
    isCurrentCostLbl: 'Is Current Cost',
  };
  public costGridstate: State = {
    skip: 0,
    take: 5,
    group: null,
    sort: [{
      field: 'subCategoryId',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public costGridSettings: GridSettings = {
    state: this.costGridstate,
    gridData: process(this.costGridData, this.costGridstate),
    columnsConfig: [
    //  {
    //  field: 'subCategoryDescription',
    //  title: this.costLblText.subCategoryDescriptionLbl,
    //  filterable: true,
    //  _width: 50,
    //},
    {
      field: 'cost',
      title: this.costLblText.costLbl,
      filterable: true,
      _width: 80,
    },
    {
      field: 'effectiveFrom',
      title: this.costLblText.effectiveFromLbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 100,
      filterable: true,
    },
    {
      field: 'effectiveTo',
      title: this.costLblText.effectiveToLbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 100,
      filterable: true,
      },
    //  {
    //  field: 'isCurrentCost',
    //  title: this.costLblText.isCurrentCostLbl,
    //  //_width: 200,
    //  filterable: false,
    //  _width: 80,
    //}
    ]
  };
  //#endregion


  initializeFormControls() {

    // #region Finish Category Controls


    this.finishCategoryForm = this.formBuilder.group({

      category: new FormControl(""),
      isCategoryActive: new FormControl(),

    });


    // #endregion

    // #region Finish Product Controls
    this.finishSampleForm = this.formBuilder.group({
      subCategoryId: new FormControl(""),
      category: new FormControl(""),
      subCategory: new FormControl(""),
      maxQty: new FormControl(),
      ec: new FormControl(""),
      colorCode: new FormControl(""),
      stockNum: new FormControl(),
      currentCostId: new FormControl(),
      stockingLevel: new FormControl(),
      currentInventory: new FormControl(),
      resetTo: new FormControl(),
      adjustment: new FormControl(),
      reorderPoint: new FormControl(),
      
      //sku: new FormControl(),
      fileUpload: new FormControl(""),
      fileUrlPath: new FormControl(""),
      inputR: new FormControl(""),
      inputG: new FormControl(""),
      inputB: new FormControl(""),
      inputURL: new FormControl(""),
      isActive: new FormControl(),
      isOnBackOrder: new FormControl(),
      isExternal: new FormControl(),
      isPDM: new FormControl(),
      width: new FormControl(),
      height: new FormControl(),
      length: new FormControl(),
      weight: new FormControl(),
      isCostHistory: new FormControl(),
    });



    // #endregion
  }

  //#region save success label common code
  initilizeSuccessLabel() {
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
  }

  //#endregion
  //#region kendo upload 
  sampleRequestImageSelected(evt: SelectEvent) {
  }
  sampleRequestUploadSuccess(evt: SuccessEvent) {
    this.subCategoryFileUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region Sample Request Grid Section
  //#region label and variable declaration
  
  finishSampleLbl = {
    categoryName: "Category",
    subCategoryDescription: "Product Description",
    colorCode: "Color Code",
    maxQtyCanBeOrdered: "Max Qty",
    maxQtyCanBeOrderedAddText: "Max Quantity",
    stockNum: "Stock #",
    stockNumAddText: "Stock Number",
    currentCostId: "Cost",
    currentInventory: "Inventory",
    currentInventoryAddText: "Current Inventory",
    reorderPoint: "Reorder Point",
    stockingLevel: "Stocking Level",
    ec: "EC",
    onBackOrder: "On Backorder",
    isActive: "IsActive",    
    resetTo: "Reset To",
    adjustment: "Adjustment +/-",
    isExternal: "External",
    isPDM: "PDM Only",
    action: "Actions",
    fileupload: "File Upload",
    urlLbl: "Url",
    skulbl: "SKU",
    updateAction: "Update",
    historyAction: "History",
    infoCategoryText: "*Note: This will update the existing category including the associated products",
    infoMaxQuantityText: "Max Quantity is optional",
    dimensions: "Item Box Dimensions (inches)",
    height: "Height",
    length: "Length",
    width: "Width",
    weight:"Weight(oz)",
    isEmptyCategoryDescription: false,
    isSubmitted: false,

    isEmptyCategory: false,
    isEmptySubCategory: false,
    isEmptyMaxqty: false,
    isEmptysku: false,
    isEmptyFinishCode: false,    
    isEmptyFileUpload: false,
    isEmptyStockNum: false,
    isEmptyReorderPoint: false,
    isEmptyCurrentCostId: false,
    isEmptyStockingLevel: false,
    isEmptyCurrentInventory: false,

  }

  //#region Category(Finish Category) dialog operations

  finishCategoryDialog = {
    opened: false,

  }
  togglefinishCategoryDialog() {
    this.sampleCategoryTitleText = "Add New Sample Category";
    this.isEditCategoryColumns = false;
    this.finishCategoryDialog.opened = !this.finishCategoryDialog.opened;
    this.resetCategoryForm();
  }
  editSampleCategory(data: ISampleSubCategory) {
    this.sampleCategoryTitleText = "Edit Sample Category";
    this.isEditCategoryColumns = true;
    this.finishCategoryDialog.opened = !this.finishCategoryDialog.opened;
    if (this.finishCategoryDialog.opened == true) {
      this.finishCategoryForm.controls.category.setValue(data.categoryName);
      this.finishCategoryForm.controls.isCategoryActive.setValue(data.isActiveCategory);
      this.addEditCategoryId = data.categoryId;
    }
    else {

      this.resetCategoryForm();
    }
  }
  editfinishCategory(data: ISampleFinish) {
    this.finishCategoryDialog.opened = !this.finishCategoryDialog.opened;
    if (this.finishCategoryDialog.opened == true) {
      this.finishCategoryForm.controls.category.setValue(data.finishCategory);
    }
    else {
      //reset

    }
  }
  public validateCategoryForm(): boolean {
    let isValid = true;
    const controls = this.finishCategoryForm.controls;
    if (this.finishSampleLbl.isSubmitted) {
      if (controls.category.value) {
        this.finishSampleLbl.isEmptyCategoryDescription = false;
      } else {
        this.finishSampleLbl.isEmptyCategoryDescription = true;
        isValid = false;
      }

    }
    return isValid;
  }

  saveSampleRequestCategory() {
    this.finishSampleLbl.isSubmitted = true;
    if (!this.validateCategoryForm()) {
      return;
    }
    this.initilizeSuccessLabel();
    this.categorySaveInProcess = true;

    var controls = this.finishCategoryForm.controls;
    const body: ISampleSubCategory = {      
      subCategoryId: 0,
      categoryId: this.addEditCategoryId,
      categoryName: controls.category.value,
      sku: 0,
      subCategoryDescription: "",
      maxQtyCanBeOrdered: 0,
      ec: "",
      colorCode: "",
      stockNum: "",
      currentCostId: 0,
      stockingLevel: 0,
      currentInventory: 0,
      reorderPoint: 0,
      r_VALUE: "",
      b_VALUE: "",
      g_VALUE: "",
      imagePath: "",
      displayOrder: 0,
      isActive: controls.isCategoryActive.value ? controls.isCategoryActive.value : false,
      isVisibleToOnlyPDMTeam: false,
      isVisibleToExternalUser: false,
      onBackOrder: false,
      isActiveCategory: false,
      absoluteURL: "",
      width: 0,
      length: 0,
      height: 0,
      weight: 0
    }
    if (this.addEditCategoryId == 0) {
      this.productSampleFulfillmentService.AddSampleCategory(body).subscribe((response: any) => {
        this.infoMessage.genericInProgress = "";
        this.categorySaveInProcess = false;
        if (response) {
          this.resetCategoryForm();
          this.successMessage = true;
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;
          this.loadFinishSampleGrid();
        } else {
          this.infoMessage.genericError = this.infoMessage.errorMessage;
        }

      })
    }
    else {
      this.productSampleFulfillmentService.UpdateSampleCategory(body).subscribe((response: any) => {
        this.infoMessage.genericInProgress = "";
        this.categorySaveInProcess = false;
        if (response) {
          // this.resetCategoryForm();
          this.successMessage = true;
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;
          this.loadFinishSampleGrid();
        } else {
          this.infoMessage.genericError = this.infoMessage.errorMessage;
        }

      })
    }
    
  }

  resetCategoryForm() {
    this.finishSampleLbl.isSubmitted = false;
    this.finishCategoryForm.reset();
    this.finishSampleLbl.isEmptyCategoryDescription = false;
    this.categorySaveInProcess = false;
    this.infoMessage = new Info();
    this.finishCategoryForm.controls.isCategoryActive.setValue(true);
    this.addEditCategoryId = 0;
  }

  //#endregion

  //#region Sub Category(Finish) dialog operations

  categoryChange(event) {        //For now  Harcoded value written for Clothing Category.
    let categoryId = event.categoryId;
    if (categoryId == 12000) {
      this.isClothCategory = true;
    }
    else {
      this.isClothCategory = false;
    }

  }

  finishSampleDialog = {
    opened: false,

  }
  toggleFinishSampleDialog() {
    this.isAddHideColumns = true;
    this.isEditHideColumns = false;
    this.isEditedSampleSubCategory = false;
    this.isCopiedSampleSubCategory = false;
    this.sampleSubCategoryTitleText = "Add Sample Sub Category";
    this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
    this.resetSubCategoryForm();
  }
  editFinishSample(data: ISampleSubCategory) {
    this.sampleSubCategoryTitleText = "Edit Sample Sub Category";
    this.isAddHideColumns = false;
    this.isEditHideColumns = true;
    this.isEditedSampleSubCategory = true;
    this.isCopiedSampleSubCategory = false;
    this.isSampleSubCategoyCost = false;
    this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
    if (this.finishSampleDialog.opened == true) {
      this.finishSampleForm.controls.subCategoryId.setValue(data.subCategoryId);
      this.selectedCategory = data.categoryName;
      this.selectedCategoryId = data.categoryId;
      this.finishSampleForm.controls.subCategory.setValue(data.subCategoryDescription);
      //this.finishSampleForm.controls.sku.setValue(data.sku);
      this.finishSampleForm.controls.ec.setValue(data.ec);
      if (data.maxQtyCanBeOrdered == 99999)
        this.finishSampleForm.controls.maxQty.setValue(null);
      else
        this.finishSampleForm.controls.maxQty.setValue(data.maxQtyCanBeOrdered);
      this.finishSampleForm.controls.colorCode.setValue(data.colorCode);
      this.finishSampleForm.controls.stockNum.setValue(data.stockNum);
      this.finishSampleForm.controls.currentCostId.setValue(data.currentCostId);
      this.finishSampleForm.controls.stockingLevel.setValue(data.stockingLevel);
      this.finishSampleForm.controls.currentInventory.setValue(data.currentInventory);
      this.finishSampleForm.controls.reorderPoint.setValue(data.reorderPoint);
      this.finishSampleForm.controls.isActive.setValue(data.isActive);
      this.inputRGB = false;
      this.inputURL = false;
      this.uploadImage = false;
      if (data.r_VALUE) {
        this.inputRGB = true;
        this.inputURL = false;
        this.uploadImage = false;
      }
      else if (data.imagePath) {
        this.inputRGB = false;
        this.inputURL = false;
        this.uploadImage = true;
      }
      else if (data.absoluteURL) {
        this.inputURL = true;
        this.uploadImage = false;
        this.inputRGB = false;
      }
      this.finishSampleForm.controls.inputR.setValue(data.r_VALUE);
      this.finishSampleForm.controls.inputG.setValue(data.g_VALUE);
      this.finishSampleForm.controls.inputB.setValue(data.b_VALUE);
      this.finishSampleForm.controls.inputURL.setValue(data.absoluteURL);
      
      this.finishSampleForm.controls.fileUrlPath.setValue(data.imagePath);
      this.filePath = data.imagePath;
      this.subCategoryFileUpload = data.imagePath; //assigning here the URL path
      if (this.selectedCategoryId == 12000) {
        this.isClothCategory = true;
      }
      else {
        this.isClothCategory = false;
      }
      this.finishSampleForm.controls.isPDM.setValue(data.isVisibleToOnlyPDMTeam);
      this.finishSampleForm.controls.isExternal.setValue(data.isVisibleToExternalUser);
      this.finishSampleForm.controls.isOnBackOrder.setValue(data.onBackOrder);
      this.finishSampleForm.controls.width.setValue(data.width);
      this.finishSampleForm.controls.height.setValue(data.height);
      this.finishSampleForm.controls.length.setValue(data.length);
      this.finishSampleForm.controls.weight.setValue(data.weight);
      this.getAllSampleSubCategoryCostHistory(data.subCategoryId);
      if (this.finishSampleForm.controls.isPDM.value) {
        this.isDisableExternal = true;
      }
      else {
        this.isDisableExternal = false;
      }
    } else {
      //reset
      this.resetSubCategoryForm();
    }
  }
  isValidateCostSwitch() {
    var controls = this.finishSampleForm.controls;
    if (controls.isCostHistory.value) {
      this.isSampleSubCategoyCost = true;
    }
    else {
      this.isSampleSubCategoyCost = false;
    }
  }

  getAllSampleSubCategoryCostHistory(id: number) {
    this.costLoading = true;
    const body: IGetSampleSubCategoryCostBySubcategoryId = {
      subCategoryId: id,      
    }
    
    this.productSampleFulfillmentService.getAllSampleSubCategoryCostHistory(body).subscribe((response: Array<any>) => {
      if (response) {
        console.log(response);
        this.costGridData = response;
        this.productSampleFulfillmentService.setCostHeaderGridData(this.costGridData);
        this.loadCostHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while loading the page.');
    })
    this.costLoading = false;
  }

  public loadCostHeaderGridData(): void {
    if (this.costGridSettings.state)
      this.costHeaderGridData = process(this.costGridData, this.costGridSettings.state);
    else
      this.costHeaderGridData = process(this.costGridData, this.costGridstate);
    this.costGridSettings.gridData = this.costHeaderGridData;
  }
  public costHeaderGridSortChange(sort): void {
    this.costGridstate.sort = sort;
    this.loadCostHeaderGridData();
  }

  public costHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.costGridstate.skip = skip;
    this.costGridstate.take;
    this.loadCostHeaderGridData();
  }

  public costHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.costGridstate = state;
    this.costGridSettings.state = this.costGridstate;
    this.loadCostHeaderGridData();
  }

  editFinishCopySample(data: ISampleSubCategory) {
    this.sampleSubCategoryTitleText = "Copied from Sample Sub Category";
    this.isAddHideColumns = true;
    this.isEditHideColumns = false;
    this.isEditedSampleSubCategory = false;
    this.isCopiedSampleSubCategory = true;
    this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
    if (this.finishSampleDialog.opened == true) {
      this.finishSampleForm.controls.subCategoryId.setValue(null);
      this.selectedCategory = data.categoryName;
      this.selectedCategoryId = data.categoryId;
      this.finishSampleForm.controls.subCategory.setValue('Copied from '+data.subCategoryDescription);
      //this.finishSampleForm.controls.sku.setValue(data.sku);
      this.finishSampleForm.controls.ec.setValue(data.ec);
      if (data.maxQtyCanBeOrdered == 99999)
        this.finishSampleForm.controls.maxQty.setValue(null);
      else
        this.finishSampleForm.controls.maxQty.setValue(data.maxQtyCanBeOrdered);
      this.finishSampleForm.controls.colorCode.setValue(data.colorCode);
      this.finishSampleForm.controls.stockNum.setValue(null);
      this.finishSampleForm.controls.currentCostId.setValue(data.currentCostId);
      this.finishSampleForm.controls.stockingLevel.setValue(data.stockingLevel);
      this.finishSampleForm.controls.currentInventory.setValue(data.currentInventory);
      this.finishSampleForm.controls.reorderPoint.setValue(data.reorderPoint);
      this.finishSampleForm.controls.isActive.setValue(data.isActive);
      this.inputRGB = false;
      this.inputURL = false;
      this.uploadImage = false;
      if (data.r_VALUE) {
        this.inputRGB = true;
        this.inputURL = false;
        this.uploadImage = false;
      }
      else if (data.imagePath) {
        this.inputRGB = false;
        this.inputURL = false;
        this.uploadImage = true;
      }
      else if (data.absoluteURL) {
        this.inputURL = true;
        this.uploadImage = false;
        this.inputRGB = false;
      }
      this.finishSampleForm.controls.inputR.setValue(data.r_VALUE);
      this.finishSampleForm.controls.inputG.setValue(data.g_VALUE);
      this.finishSampleForm.controls.inputB.setValue(data.b_VALUE);
      this.finishSampleForm.controls.inputURL.setValue(data.absoluteURL);

      this.finishSampleForm.controls.fileUrlPath.setValue(data.imagePath);
      this.filePath = data.imagePath;
      this.subCategoryFileUpload = data.imagePath; //assigning here the URL path
      if (this.selectedCategoryId == 12000) {
        this.isClothCategory = true;
      }
      else {
        this.isClothCategory = false;
      }
      this.finishSampleForm.controls.isPDM.setValue(data.isVisibleToOnlyPDMTeam);
      this.finishSampleForm.controls.isExternal.setValue(data.isVisibleToExternalUser);
      this.finishSampleForm.controls.isOnBackOrder.setValue(data.onBackOrder);      
      this.finishSampleForm.controls.width.setValue(data.width);
      this.finishSampleForm.controls.height.setValue(data.height);
      this.finishSampleForm.controls.length.setValue(data.length);
      this.finishSampleForm.controls.weight.setValue(data.weight);
      if (this.finishSampleForm.controls.isPDM.value) {
        this.isDisableExternal = true;
      }
      else {
        this.isDisableExternal = false;
      }
    } else {
      //reset
      this.resetSubCategoryForm();
    }
  } 

  public validateSubCategoryForm(): boolean {
    let isValid = true;
    const controls = this.finishSampleForm.controls;
    if (this.finishSampleLbl.isSubmitted) {
      const t = controls.category.value ? controls.category.value.categoryName : "";
      if (t) {
        this.finishSampleLbl.isEmptyCategory = false;
      } else {
        this.finishSampleLbl.isEmptyCategory = true;
        isValid = false;
      }

      if (controls.subCategory.value) {
        this.finishSampleLbl.isEmptySubCategory = false;
      } else {
        this.finishSampleLbl.isEmptySubCategory = true;
        isValid = false;
      }

      //if (controls.maxQty.value) {
      //  this.finishSampleLbl.isEmptyMaxqty = false;
      //} else {
      //  this.finishSampleLbl.isEmptyMaxqty = true;
      //  isValid = false;
      //}

      if (controls.stockNum.value) {
        this.finishSampleLbl.isEmptyStockNum = false;
      } else {
        this.finishSampleLbl.isEmptyStockNum = true;
        isValid = false;
      }

      if (controls.currentCostId.value) {
        this.finishSampleLbl.isEmptyCurrentCostId = false;
      } else if (controls.currentCostId.value == 0) {
        this.finishSampleLbl.isEmptyCurrentCostId = false;
      } else {
        this.finishSampleLbl.isEmptyCurrentCostId = true;
        isValid = false;
      }
      if (controls.stockingLevel.value) {
        this.finishSampleLbl.isEmptyStockingLevel = false;
      }
      else if (controls.stockingLevel.value == 0) {
        this.finishSampleLbl.isEmptyStockingLevel = false;
      } else {
        this.finishSampleLbl.isEmptyStockingLevel = true;
        isValid = false;
      }

      if (controls.currentInventory.value ) {
        this.finishSampleLbl.isEmptyCurrentInventory = false;
      }
      else if (controls.currentInventory.value == 0) {
        this.finishSampleLbl.isEmptyCurrentInventory = false;
      }
      else {
        this.finishSampleLbl.isEmptyCurrentInventory = true;
        isValid = false;
      }
      if (controls.reorderPoint.value) {
        this.finishSampleLbl.isEmptyReorderPoint = false;
      } else {
        this.finishSampleLbl.isEmptyReorderPoint = true;
        isValid = false;
      }
      
      // if (controls.sku.value) {
      //   this.finishSampleLbl.isEmptysku = false;
      //} else {
      //  this.finishSampleLbl.isEmptysku = true;
      //  isValid = false;
      //}

      //if (controls.fileUpload.value) {
      //  this.finishSampleLbl.isEmptyFileUpload = false;
      //} else {
      //  this.finishSampleLbl.isEmptyFileUpload = true;
      //  isValid = false;
      //}

      //if (this.isClothCategory) {
      //  if (controls.gender.value.name != "") {
      //    this.finishSampleLbl.isEmptyGender = false;
      //  } else {
      //    this.finishSampleLbl.isEmptyGender = true;
      //    isValid = false;
      //  }

      //  if (controls.size.value.name != "") {
      //    this.finishSampleLbl.isEmptySize = false;
      //  } else {
      //    this.finishSampleLbl.isEmptySize = true;
      //    isValid = false;
      //  }
      //}

    }
    return isValid;
  }

  updateInventorySampleSubCategory() {
    //Validate
    var controls = this.finishSampleForm.controls;
    if (controls.resetTo.value == null && controls.adjustment.value ==null) {
      return true;
    }
    this.subCategorySaveInProcess = true;
    //Update Inventory value
    let updatedInventory = 0;
    let resetVal = controls.resetTo.value;
    if (resetVal != null) {
      if (resetVal >= 0 ) {
        updatedInventory = Number(controls.resetTo.value);
      }
    }
     else if (controls.adjustment.value) {
      updatedInventory = Number(controls.currentInventory.value) + Number(controls.adjustment.value);
    }
    else {
      updatedInventory = Number(controls.currentInventory.value);
    }
    //set on Back Order
    if (updatedInventory <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    } else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
    //set Is external
    if (controls.isPDM.value) {
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    const body: ISampleSubCategory = {
      subCategoryId: controls.subCategoryId.value ? controls.subCategoryId.value : 0,
      categoryId: controls.category.value.categoryId,
      categoryName: controls.category.value.categoryName,
      sku: 0,
      subCategoryDescription: controls.subCategory.value,
      maxQtyCanBeOrdered: Number(controls.maxQty.value),
      ec: controls.ec.value,
      colorCode: controls.colorCode.value,
      stockNum: controls.stockNum.value,
      currentCostId: controls.currentCostId.value,
      stockingLevel: controls.stockingLevel.value,
      currentInventory: updatedInventory,
      reorderPoint: controls.reorderPoint.value,
      //absoluteURL: controls.inputURL.value,
      r_VALUE: controls.inputR.value,
      b_VALUE: controls.inputB.value,
      g_VALUE: controls.inputG.value,
      imagePath: this.subCategoryFileUpload, //passing selected file URL here      
      displayOrder: 0,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      isVisibleToOnlyPDMTeam: controls.isPDM.value ? controls.isPDM.value : false,
      isVisibleToExternalUser: controls.isExternal.value ? controls.isExternal.value : false,
      onBackOrder: controls.isOnBackOrder.value ? controls.isOnBackOrder.value : false,
      isActiveCategory: false,
      absoluteURL: controls.inputURL.value,
      width: controls.width.value ? controls.width.value : 0,
      length: controls.length.value ? controls.length.value : 0,
      height: controls.height.value ? controls.height.value : 0,
      weight: controls.weight.value ? controls.weight.value : 0
    }

    this.productSampleFulfillmentService.UpdateInventorySampleSubCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.subCategorySaveInProcess = false;
      if (response) {
        if (response.subCategoryId > 0 && this.isEditedSampleSubCategory) {
          this.finishSampleForm.controls.resetTo.setValue(null);
          this.finishSampleForm.controls.adjustment.setValue(null);
          this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
          this.editFinishSample(response);
        } else {
          this.resetSubCategoryForm();
        }
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadFinishSampleGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    });
    
  }

  //public isSubCategoryExist() : boolean {
  //  let isValid = false;
  //  const controls = this.finishSampleForm.controls;
  //  const stockBody: ISampleSubCategoryExist = {
  //    stockNumber: controls.stockNum.value
  //  }
  //  this.productSampleFulfillmentService.GetSampleSubCatgeoryExist(stockBody).subscribe((response: any) => {
  //    console.log(response);
  //    if (response.length > 0) {
  //      this.infoMessage.genericInProgress = "";
  //      this.infoMessage.genericError = "Sample Sub Category already exist with the stock number";
  //      this.subCategorySaveInProcess = false;
  //      console.log('step1 stock');
  //      isValid = true;
  //    }
  //  });    
  //  return isValid;
  //}

  async saveSampleRequestSubCategory() {
    this.finishSampleLbl.isSubmitted = true;
    if (!this.validateSubCategoryForm()) {
      return;
    }
    
    this.initilizeSuccessLabel();
    this.subCategorySaveInProcess = true;

    var controls = this.finishSampleForm.controls;
    let inventory = Number(controls.currentInventory.value);
    //set on Back Order
    if (inventory <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    } else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
    //set Is external
    if (controls.isPDM.value) {
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    const body: ISampleSubCategory = {
      subCategoryId: controls.subCategoryId.value ? controls.subCategoryId.value : 0,
      categoryId: controls.category.value.categoryId,
      categoryName: controls.category.value.categoryName,
      sku: 0,
      subCategoryDescription: controls.subCategory.value,
      maxQtyCanBeOrdered: Number(controls.maxQty.value),
      ec: controls.ec.value,
      colorCode: controls.colorCode.value,
      stockNum: controls.stockNum.value,
      currentCostId: controls.currentCostId.value,
      stockingLevel: controls.stockingLevel.value,
      currentInventory: controls.currentInventory.value,
      reorderPoint: controls.reorderPoint.value,
      //absoluteURL: controls.inputURL.value,
      r_VALUE: controls.inputR.value,
      b_VALUE: controls.inputB.value,
      g_VALUE: controls.inputG.value,
      imagePath: this.subCategoryFileUpload, //passing selected file URL here      
      displayOrder: 0,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      isVisibleToOnlyPDMTeam: controls.isPDM.value ? controls.isPDM.value : false,
      isVisibleToExternalUser: controls.isExternal.value ? controls.isExternal.value : false,
      onBackOrder: controls.isOnBackOrder.value ? controls.isOnBackOrder.value : false,
      isActiveCategory: false,
      absoluteURL: controls.inputURL.value,
      width: controls.width.value ? controls.width.value : 0,
      length: controls.length.value ? controls.length.value : 0,
      height: controls.height.value ? controls.height.value : 0,
      weight: controls.weight.value ? controls.weight.value : 0
    }

    //Valdiate Sample sub category with stock
    //var test = this.isSubCategoryExist();
    const stockBody: ISampleSubCategoryExist = {
      stockNumber: controls.stockNum.value,
      subCategoryId: controls.subCategoryId.value ? controls.subCategoryId.value : 0,
    }
    try {
      let resp = await this.productSampleFulfillmentService.GetSampleSubCatgeoryExist(stockBody).toPromise();
      console.log(resp);
      if (resp && resp.length > 0) {
          this.infoMessage.genericInProgress = "";
          this.infoMessage.genericError = "Sample Sub Category already exist with the stock number";
          this.subCategorySaveInProcess = false;
          return;
       }     
    }
    catch (e) {}
       
    
    this.productSampleFulfillmentService.AddUpdateSampleSubCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.subCategorySaveInProcess = false;
      if (response) {
        if (response.subCategoryId > 0 && this.isEditedSampleSubCategory) {
          this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
          this.editFinishSample(response);
        } else {
          this.resetSubCategoryForm();
        }        
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadFinishSampleGrid();

      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    });

  }

  validateSubCategoryOnBackOrder() {
    var controls = this.finishSampleForm.controls;
    if (controls.currentInventory.value <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    }
    else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
  }
  validateSubCategoryIsExternal() {
    var controls = this.finishSampleForm.controls;
    if (controls.isPDM.value) {
      this.isDisableExternal = true;
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    else {
      this.finishSampleForm.controls.isExternal.setValue(false);
      this.isDisableExternal = false;
    }
  }
  resetSubCategoryForm() {
    this.finishSampleLbl.isSubmitted = false;
    this.finishSampleForm.reset();
    this.finishSampleLbl.isEmptyCategory = false;
    this.finishSampleLbl.isEmptySubCategory = false;
    this.finishSampleLbl.isEmptyMaxqty = false;
    this.finishSampleLbl.isEmptyFinishCode = false;
    this.selectedCategory = "";
    this.selectedCategoryId = 0;
    this.selectedGender = "";
    this.selectedSize = "";
    this.subCategorySaveInProcess = false;
    this.infoMessage = new Info();
    this.isClothCategory = false;
    this.finishSampleForm.controls.isActive.setValue(true);   

    this.finishSampleLbl.isEmptyFileUpload = false;
    this.filePath = "";
    this.subCategoryFileUpload = "";
    this.isEditedSampleSubCategory = false;
    this.isCopiedSampleSubCategory = false;
    this.uploadImage = false;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    this.isDisableExternal = false;
    //this.sampleSubCategoryTitleText = "";
  }

  //#endregion

  //#region Grid data binding
  public loadFinishSampleGrid(): void {
    this.finishSampleLoading = true;
    this.productSampleFulfillmentService.getSampleSubCategories().subscribe((response) => {
      this.bindFinishSampleGrid();
      this.finishSampleLoading = false;

    });
  }
  //#endregion

  //#region pagination, sorting,filtering for grid

  public finishSampleGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindFinishSampleGrid(): void {
    const data = this.productSampleFulfillmentService.sampleSubCategory;

    this.finishSampleGridView = process(data, this.finishSampleGridstate);
    let filterArray = this.productSampleFulfillmentService.sampleSubCategory;
    let tempArray = filterArray.filter((v, i, a) => a.findIndex(t => (t.categoryId === v.categoryId)) === i);
    tempArray = tempArray.sort((a, b) => a.categoryName > b.categoryName ? 1 : -1);
    this.categoryData = tempArray as ISampleCategory[];
  }

  public finishSampleGridSortChange(sort: SortDescriptor[]): void {
    this.finishSampleGridstate.sort = sort;
    this.bindFinishSampleGrid();
  }
  public finishSampleGridPageChange({ skip, take }: PageChangeEvent): void {
    this.finishSampleGridstate.skip = skip;
    this.finishSampleGridstate.take = take;
    this.bindFinishSampleGrid();
  }

  public finishSampleDataStateChange(state: DataStateChangeEvent): void {
    this.finishSampleGridstate = state;
    this.bindFinishSampleGrid();
  }
  //#endregion

  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete finish sample subcategory ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.productSampleFulfillmentService.DeleteSampleSubCategory(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const subCategoryId = this.gridItemToRemove.subCategoryId;
      //const sku = this.gridItemToRemove.sku;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected finish sample subcategory has been removed.");

      if (this.productSampleFulfillmentService.sampleSubCategory) {
        //This is a Local Remove
        const index = (this.productSampleFulfillmentService.sampleSubCategory).findIndex(r => r.subCategoryId === subCategoryId);
        (this.productSampleFulfillmentService.sampleSubCategory).splice(index, 1);
        this.bindFinishSampleGrid();

      }

    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }
  async redirectToBudgetAllocationPage() {
    this.router.navigate(['sample-request-admin/admin-budget-report']);
  }
  async redirectToInventoryUsagePage() {
    this.router.navigate(['sample-request-admin/sample-request-inventory-usage-report']);
  }
  async redirectToOrderHistoryPage() {
    this.router.navigate(['sample-request-admin/sample-request-order-history']);
  }
  //#endregion
}
